import { StyledNavListItem } from "../style";

const NavListItem = ({ selected, handleClick, title, image, smallIcon }) => {
  return (
    <StyledNavListItem selected={selected} $smallIcon={smallIcon}>
      <button onClick={handleClick}>
        {image}
        <p>{title}</p>
      </button>
    </StyledNavListItem>
  );
};

export default NavListItem;
